import { useAtomValue } from 'jotai'

import {
  showValidationResultsAtom,
  validationResultsAtom
} from 'Automations/automationEditor/atoms'
import { HANDLE_VALIDATION_FIELD_PREFIX } from '../../constants'

type UseNodeHasConfigErrors = (props: { nodeId: string }) => boolean

export const useNodeHasConfigErrors: UseNodeHasConfigErrors = ({ nodeId }) => {
  const validationResults = useAtomValue(validationResultsAtom)
  const showValidationResults = useAtomValue(showValidationResultsAtom)

  if (!showValidationResults) return false

  const resultsForNodeId = validationResults[nodeId]
  if (!resultsForNodeId) return false

  return Object.keys(resultsForNodeId).some(
    fieldId =>
      !fieldId.startsWith(HANDLE_VALIDATION_FIELD_PREFIX) &&
      resultsForNodeId[fieldId].length > 0
  )
}
